// The app picker's remembered selection (an app, or All apps) and the queue the person last opened,
// so the ticket page's "back" link returns to that queue with its filters (module-10 Section 2; CT-001).
import { readLocal, writeLocal } from './utils';

const LAST_APP_KEY = 'feedback:last-app';
/** Stored for the All apps selection; never an app ID, so the picker's app lookup ignores it. */
const ALL_APPS = 'all';

/** The app last chosen in the picker, or null for All apps (callers check it's still one of theirs). */
export function lastAppId(): string | null {
  const value = readLocal(LAST_APP_KEY);
  return value === ALL_APPS ? null : value;
}

/** `null` remembers All apps. */
export function rememberApp(appId: string | null): void {
  writeLocal(LAST_APP_KEY, appId ?? ALL_APPS);
}

/** The queue filters last used per queue in this tab, so "back to the queue" keeps them (S4 -> S5 -> S4). */
const lastQueueSearches = new Map<string, Record<string, unknown>>();
/** The queue last opened in this tab: an app's ID, null for All tickets, undefined for none yet. */
let lastQueue: string | null | undefined;

/** `appId` null is the All tickets queue. */
export function rememberQueueSearch(appId: string | null, search: Record<string, unknown>): void {
  lastQueue = appId;
  lastQueueSearches.set(appId ?? ALL_APPS, search);
}

export function lastQueueSearch(appId: string | null): Record<string, unknown> {
  return lastQueueSearches.get(appId ?? ALL_APPS) ?? {};
}

/** True when the last queue opened in this tab was All tickets. */
export function cameFromAllTickets(): boolean {
  return lastQueue === null;
}
